import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Theme, makeStyles } from '@material-ui/core'

import { specTableStyleProps } from './Spectable.types'

const specTableStyle = makeStyles((theme: Theme) => ({
    specTable: {
        border: '1px solid #DBDFE0',
        marginBottom: theme.spacing(0),
        '& .tr': {
            '& :last-child': {
                '& .td': {
                    borderBottom: 0,
                },
            },
            '&:first-child': {
                borderTop: '1px solid #C9C9C9',
            },
            '&.grouped-row': {
                height: 35,
            },
            minWidth: (props: specTableStyleProps) =>
                props.tableMinWidth ?? 'auto',
            width: 'fit-content',
        },
        '& .th, & .td': {
            padding: 3,
            wordBreak: 'break-all',
            backgroundColor: theme.palette.common.white,
            overflow: 'hidden',
        },
        '& .td': {
            margin: 'auto',
            height: (props: specTableStyleProps) =>
                props.groupedCellHeight
                    ? pxToRem(props.groupedCellHeight)
                    : 'auto',
        },

        '&.sticky': {
            '& .header': {
                position: 'sticky',
                zIndex: 100,
                top: 0,
            },
            '& .body': (props: specTableStyleProps) => ({
                position: 'relative',
                zIndex: 0,
                height: props.lazyLoading ? 700 : 'inherit',
            }),
            '& [data-sticky-td]': {
                position: 'sticky',
            },
        },
        '&.full-scroll': {
            overflow: 'auto',
        },
        '&.hideScroll': {
            overflowX: 'hidden',
        },
        '&.horz-scroll': {
            overflowX: 'auto',
        },
        '&.vertical-scroll': {
            overflowY: 'auto',
            overflowX: 'hidden',
            border: 'none',
        },
        '&.load-next-available': {
            marginBottom: theme.spacing(1),
        },
        '&.no-load-next-available': {
            marginBottom: theme.spacing(1),
        },
    },
    tableBodyContainer: {
        position: 'relative',
    },
    cellPadding: {
        paddingLeft: theme.spacing(1.5),
    },
    loadNextContainer: {
        height: 60,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        bottom: 0,
        width: '100%',
    },
    centerContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 130,
    },
    grayText: {
        ...theme.typography.h1,
        color: theme.palette.grey[700],
    },
    bottomMargin: {
        marginBottom: theme.spacing(1),
    },
}))

export const sharedTableStyles = makeStyles((theme: Theme) => ({
    fullWidth: {
        width: '100%',
    },
    textOverflowEllipsis: {
        wordBreak: 'unset',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    cellPadding: {
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1),
    },
}))

export default specTableStyle
